module.exports = __webpack_public_path__ + "img/6-min.e8a3b6ab.jpg";